import type React from 'react'

import { useCommunicationMode } from '@hooks'

import { PrivateNavbarIntercomLauncherButton } from '@components/Intercom'
import { MessageToAccountantButton } from '@components/navigations/elements/buttons/MessageToAccountantButton'

import { COMMUNICATION_MODE_HUBSPOT, COMMUNICATION_MODE_INTERCOM } from '@constants'

import { useOpenSupportSlideOver } from './useOpenSupportSlideOver'

interface NavbarSupportLauncherButtonProps {
  className?: string
  /** Compact-dropdown presentation — only the hubspot button needs it; the Intercom one styles itself. */
  isCompact?: boolean
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  showIconButton?: boolean
}

/**
 * Navbar support entry: the Intercom launcher or the message-to-accountant button by communication
 * mode. Renders nothing while the mode is unresolved.
 */
export function NavbarSupportLauncherButton({
  className,
  isCompact = false,
  onClick,
  showIconButton = false,
}: NavbarSupportLauncherButtonProps) {
  const communicationMode = useCommunicationMode()
  const openSlideOver = useOpenSupportSlideOver()

  if (communicationMode === COMMUNICATION_MODE_HUBSPOT) {
    return (
      <MessageToAccountantButton
        className={className}
        isCompact={isCompact}
        isDesktop={showIconButton}
        onClick={event => {
          openSlideOver()
          onClick?.(event)
        }}
      />
    )
  }
  if (communicationMode === COMMUNICATION_MODE_INTERCOM) {
    return (
      <PrivateNavbarIntercomLauncherButton className={className} onClick={onClick} showIconButton={showIconButton} />
    )
  }
  return null
}
